<template>
	<v-container>
			<div class="base-page">
				<logo-with-title :title="$t('register')"/>

				<v-row justify="center">
					<v-col>
						<v-alert v-if="errors.token" dense outlined type="error">
							<p
								v-for="(error, index) in errors.token"
								:key="error + index"
							>
								{{ error }}
							</p>
						</v-alert>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<register-form :loading="loading" :errors = "errors" @submit="onSubmit" @login="gotoLogin"/>
						<lang-select />
					</v-col>
				</v-row>

			</div>
	</v-container>

</template>

<script>
import { types } from "src/store/modules/Auth.module";
import ProjectModule from "@/store/modules/Project.module";
import LangSelect from "../../components/LangSelect.vue";
import RegisterForm from "./RegisterForm";
import LogoWithTitle from "@/components/LogoWithTitle";
export default {
	name: "RegistrationView",
	components: { LogoWithTitle, LangSelect, RegisterForm},
	props: {},
	data: () => ({
		disabled: false,
		form: {},
		errors: {
		name: [],
		email: [],
		password: [],
		password_confirmation: [],
	},
		loading: false
	}),
	computed: {
		plan() {
			return this.$store.state.PlanModule.plan;
		},
		project() {
			return this.$store.state.ProjectModule.project;
		},
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(
				ProjectModule.types.GET,
				id,
			);
		}
	},
	methods: {
		async onSubmit(param) {
			window.grecaptcha.ready(() => {
				window.grecaptcha.execute('6LfjJxIpAAAAAMF-A4Wy-3N5inutHYoivHiLFpR2', { action: 'submit' }).then(async (token) => {
					try {
						await this.$store.dispatch(
							types.REGISTER,
							param.form,
						);
						await this.$router.push({ path: `/plans?p=${this.$route.query.p}` });

					} catch (error) {
						if (
							error.response &&
							error.response.status === 422 &&
							error.response.data &&
							error.response.data.errors
						) {
							this.errors = error.response.data.errors;
						}
					}
				});
			});


		},
		gotoLogin() {
			this.$router.push({ path: `/signin?p=${this.$route.query.p}` });
		},
	},
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.background-image {
	z-index: -1 !important;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	webkit-background-size: cover !important;
	-moz-background-size: cover !important;
	-o-background-size: cover !important;
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
	filter: blur(6px);
	-webkit-filter: blur(6px);
	transform: scale(1.03)
}

.page {
	width: 90%;
	margin: auto;
	background-color: $background;

	@include responsive($mobile) {
		max-width: $mobile !important;
		max-height: $mobile-height;
	}

	.project-name {
		&--col {
			padding: 0;

			div {
				height: 40px;
				width: 220px;
				background: #4595cc 0 0 no-repeat padding-box;
				border-radius: 0 0 20px 20px;
				opacity: 1;
			}
		}
	}
}
</style>
